import React from 'react'
import {FONT_FAMILY_LIST} from "../../../../common/constants/designer.constant";
import PreviewFontFamily from "./preview-font-family";
import PreviewGoogleFonts from "../../../../common/fonts/preview-google-fonts";
import {GOOGLE_FONTS} from "../../../../common/fonts/google-fonts";
import _ from "lodash";
import SelectGoogleFonts from "../../../../common/fonts/select-google-fonts";
import SelectCustomFonts from "../../../../common/fonts/select-custom-fonts";
import SelectFonts from "../../../../common/fonts/select-fonts";

const EditFontDetails = ({displayTextItem, handleFontDetailsChanges}) => {

    return (
        <>

            <div className="flex justify-between">
                <div className="ml-2 field-label">
                    Font Size & Family
                </div>

                <div className="-mt-2 flex justify-center items-center">
                    <div className={'m-1'}>
                        <PreviewFontFamily
                            parentForm={displayTextItem}
                            handleFontDetailsChanges={handleFontDetailsChanges}/>
                    </div>

                    <div className={'m-1'}>
                        <PreviewGoogleFonts
                            parentForm={displayTextItem}
                            handleFontDetailsChanges={handleFontDetailsChanges}/>
                    </div>
                </div>
            </div>

            <div className="flex flex-wrap justify-start items-start move-up-10">
                <div className="field-group-container flex justify-start items-start">
                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field w-20"
                            id="fontSize"
                            name="fontSize"
                            value={displayTextItem?.fontSize}
                            onChange={(event) => {
                                handleFontDetailsChanges(event, displayTextItem);
                            }}>
                        </input>
                    </div>

                    <div className={"mt-2 flex"}>
                        <SelectFonts
                            parentForm={displayTextItem}
                            handleFontDetailsChanges={handleFontDetailsChanges}/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditFontDetails
